import { render, staticRenderFns } from "./TalkCard.vue?vue&type=template&id=0f1a5ae7&"
import script from "./TalkCard.vue?vue&type=script&lang=js&"
export * from "./TalkCard.vue?vue&type=script&lang=js&"
import style0 from "./TalkCard.vue?vue&type=style&index=0&id=0f1a5ae7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports